import Axios from 'axios'

export async function getShippingKangu(
  cubagens,
  dataEnterprise,
  totalCaixas,
  proximaCaixa,
  isAgrupped
) {
  if (cubagens.length !== 0) {
    try {
      const cubagemKangu = []

      const valorTotalCub = cubagens?.reduce((acc, item) => {
        return acc + parseFloat(item.cubagensKangu?.valor_total)
      }, 0)

      const subTributaria = parseFloat(cubagens[0].sub_tributaria) ?? 0

      const valorTotalMercadoria = valorTotalCub

      const valorTotalMais20 = valorTotalMercadoria + valorTotalMercadoria * 0.2 // 20% de margem de segurança

      cubagens?.forEach((item) => {
        cubagemKangu?.push({
          altura: item.cubagensKangu?.altura,
          largura: item.cubagensKangu?.largura,
          comprimento: item.cubagensKangu?.comprimento,
          peso: parseFloat(item.cubagensKangu.pesoCaixa),
          quantidade: '1',
          valor: valorTotalMais20, // 20% de margem de segurança
        })
      })

      const proximaCubagem = []

      const valorTotalKangu = parseFloat(cubagemKangu[0].valor)

      const totalMaisSubTributaria = valorTotalKangu + subTributaria

      const valorTotalMais20Prox =
        totalMaisSubTributaria + totalMaisSubTributaria * 0.2 // 20% de margem de segurança

      if (isAgrupped) {
        cubagens?.forEach((item) => {
          proximaCubagem?.push({
            altura: proximaCaixa?.altura,
            largura: proximaCaixa?.largura,
            comprimento: proximaCaixa?.comprimento,
            peso: parseFloat(proximaCaixa.peso),
            quantidade: '1',
            valor: cubagemKangu[0].valor, // 10% de margem de segurança
            // valor: valorTotal,
          })
        })
      }

      const proxCub = proximaCubagem.slice(0, 1)

      const paramsKangu = {
        dados_produto: !isAgrupped ? cubagemKangu : proxCub,
        cep_destino: dataEnterprise?.ent_cep,
      }

      const responseKangu = await Axios.post(
        'https://api.innovationbrindes.com.br/api/site/v2/frete-transp-kangu/consulta-frete-api',
        paramsKangu
      )

      const responseFormatted = responseKangu.data.map((item, index) => {
        return {
          nome: item.transp_nome,
          nome_transp: item.transp_nome,
          caixa_kangu: proximaCaixa?.value,
          isKangu: true,
          id: index,
          id_company: null,
          original_nome: item.descricao,
          performance: null,
          preco: item.vlrFrete + item.vlrFrete * 0.1,
          prazo: {
            min: 1,
            max: item.prazoEnt + 1,
          },
          referencia: item.referencia,
          numero_nota: dataEnterprise?.numero_nota,
          tipo_servico: item.servico,
          tipo_transportadora: 'K',
          valor_simulacao: item.vlrFrete + item.vlrFrete * 0.1,
          cnpj_transportadora: item.cnpjTransp,
          razao_social_transp: item.transp_nome,
          quantidade_caixas: totalCaixas,
          valida_frete: dataEnterprise.valida_frete,
          originalValue: parseFloat(item.vlrFrete),
        }
      })

      const kanguNotRetira = responseFormatted.filter(
        (item) => item.nome !== 'Retira'
      )

      const responseOrder = kanguNotRetira.sort((a, b) => a.preco - b.preco)

      return responseOrder
    } catch (error) {
      console.log('error', error)
    }
  }
}
